import { connect } from 'react-redux';
import { getActiveModal, hideModal, MODAL_EDIT_DEPARTMENT } from "../../../../reducers/common/activeModal";
import { resetSubmitFormData } from "../../../../reducers/common/submitForm";
import { getTranslation } from "../../../../reducers/common/localization";
import EditDepartmentModal from "./EditDepartmentModal";
import { fetchEditDepartment, getDepartmentName, getDepartmentId, getDepartmentEmail } from "../../../../reducers/organization/department";

const mapStateToProps = state => {
    return {
        departmentId: getDepartmentId(state),
        departmentName: getDepartmentName(state),
        departmentEmail: getDepartmentEmail(state),
        isOpen: getActiveModal(state).modalKey === MODAL_EDIT_DEPARTMENT,
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onDepartmentEdit: (departmentId, departmentData) => dispatch(fetchEditDepartment(departmentId, departmentData)),
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDepartmentModal);



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/departmentModal/editDepartmentModal/EditDepartmentModal.container.js